import * as THREE from "three";
import {RGBELoader} from "three/addons/loaders/RGBELoader";

import store from "../store";
import {ThreeViewer} from "./internal/ThreeViewer";
import initializeKeyboardEvents from "./internal/events/handlers/keyboardHandler";

//import { PMREMGenerator } from 'three';
//import { Scene, WebGLRenderer } from 'three';
//import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment';

const initialize3dEnvironment = async () => {

    
    const container = document.getElementById("mainCanvas_preview");
    store.status.initializing = true;
    
    if (container) {
        
        const threeViewer = new ThreeViewer({
            element: container,
        })
        await threeViewer.initViewer()
        initializeKeyboardEvents()
        
        
        // Our Custom environment map
        const rgbLoader = new RGBELoader().setPath('assets/hdr/');
        const envMapTexture = await rgbLoader.loadAsync("marry10.hdr")
        envMapTexture.mapping = THREE.EquirectangularReflectionMapping;
        envMapTexture.encoding = THREE.sRGBEncoding;
        
        threeViewer.scene.environment = envMapTexture;
        threeViewer.scene.background = null
        
        
        // Natural environment map
        //const pmremGenerator = new PMREMGenerator(threeViewer.renderer);
        //const neutralEnv = pmremGenerator.fromScene(new RoomEnvironment()).texture;
        //threeViewer.scene.environment = envMapTexture;
        //threeViewer.scene.background = envMapTexture;
        
        
        window.threeViewer = threeViewer;
        window.leftP = 1.2
        
        
    }
}
export default initialize3dEnvironment
